import typography from 'theme/config/typography';

export default {
  root: {
    ...typography.h3,
    padding: '20px',
  },
};
